import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ManagementMeasureDimensions from '../../measure-dimensions/conatiners/measure-dimensions';
import ManagementMeasureWeights from '../../measure-weights/conatiners/measure-weights';

export const Measures = () => {
  const tabItems=[
    {
        id:1,
        title:'Measure Dimensions',
        component:<ManagementMeasureDimensions/>,
    isVisible:true,
    },
    {
        id:2,
        title:'Measure Weights',
        component:<ManagementMeasureWeights/>,
    isVisible:true,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-2 overflow-auto h-screen"> 
      <TabContainer tabItems={tabItems} />

       </div>
  )
}
export default Measures;
